/**
 * @generated SignedSource<<04f8f007b2ad4d91f1540d284133dbd3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type SavePriceSimulationScenarioInput = {
  name: string;
  overrides: ReadonlyArray<PriceOverrideInput>;
};
export type PriceOverrideInput = {
  daily?: number | null | undefined;
  hourly?: number | null | undefined;
  monthly?: number | null | undefined;
  monthlyCap?: number | null | undefined;
  outboundNetworkTransferPerGigabyte?: number | null | undefined;
  percentagePerProject?: number | null | undefined;
  pricePerUnit?: number | null | undefined;
  sku: string;
};
export type AnalysisSimulationViewSaveScenarioMutation$variables = {
  input: SavePriceSimulationScenarioInput;
};
export type AnalysisSimulationViewSaveScenarioMutation$data = {
  readonly savePriceSimulationScenario: {
    readonly id: string;
    readonly name: string;
  };
};
export type AnalysisSimulationViewSaveScenarioMutation = {
  response: AnalysisSimulationViewSaveScenarioMutation$data;
  variables: AnalysisSimulationViewSaveScenarioMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "PriceSimulationScenario",
    "kind": "LinkedField",
    "name": "savePriceSimulationScenario",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AnalysisSimulationViewSaveScenarioMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AnalysisSimulationViewSaveScenarioMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "d486976b9cf99d17395660d5b4b29423",
    "id": null,
    "metadata": {},
    "name": "AnalysisSimulationViewSaveScenarioMutation",
    "operationKind": "mutation",
    "text": "mutation AnalysisSimulationViewSaveScenarioMutation(\n  $input: SavePriceSimulationScenarioInput!\n) {\n  savePriceSimulationScenario(input: $input) {\n    id\n    name\n  }\n}\n"
  }
};
})();

(node as any).hash = "f6087143f0aef4d5227979175c261a94";

export default node;
